// extracted by mini-css-extract-plugin
module.exports = {"local-currency":"LocalCurrencyConversion_local-currency__tdN8Z"};